export interface PostalCodeHint {
  pattern: string;
  example: string;
}

// Generated from `postal-codes-js` v2.5.2 format files (formats/*.json) + a small set of
// hand overrides where the library's own description is missing, self-contradictory, or
// uses a placeholder convention the user wouldn't understand (CC/N/L → country code / digit / letter).
const HINT_BY_ALPHA2: Readonly<Record<string, PostalCodeHint>> = {
  AD: { pattern: 'AD999', example: 'AD500' },
  AF: { pattern: '9999', example: '1234' },
  AI: { pattern: 'AI-2640', example: 'AI-2640' },
  AL: { pattern: '9999', example: '1234' },
  AM: { pattern: '9999', example: '1234' },
  AQ: { pattern: 'BIQQ 1ZZ', example: 'BIQQ 1ZZ' },
  AR: { pattern: '9999', example: '1234' },
  AS: { pattern: '99999', example: '12345' },
  AT: { pattern: '9999', example: '1234' },
  AU: { pattern: '9999', example: '1234' },
  AX: { pattern: '99999 or AX-99999', example: 'AX-12345' },
  AZ: { pattern: 'AZ9999', example: 'AZ1234' },
  BA: { pattern: '99999', example: '12345' },
  BB: { pattern: 'BB99999', example: 'BB12345' },
  BD: { pattern: '9999', example: '1234' },
  BE: { pattern: '9999', example: '1234' },
  BG: { pattern: '9999', example: '1234' },
  BH: { pattern: '999 or 9999', example: '1234' },
  BL: { pattern: '97133', example: '97133' },
  BN: { pattern: 'AA9999', example: 'KA1131' },
  BO: { pattern: '9999', example: '1234' },
  BR: { pattern: '99999-999', example: '01310-100' },
  BT: { pattern: '99999', example: '12345' },
  BY: { pattern: '999999', example: '123456' },
  CA: { pattern: 'A9A 9A9', example: 'K1A 0B1' },
  CC: { pattern: '9999', example: '1234' },
  CH: { pattern: '9999', example: '1234' },
  CL: { pattern: '9999999', example: '1234567' },
  CN: { pattern: '999999', example: '123456' },
  CO: { pattern: '999999', example: '123456' },
  CR: { pattern: '99999', example: '12345' },
  CU: { pattern: '99999', example: '12345' },
  CV: { pattern: '9999', example: '1234' },
  CX: { pattern: '9999', example: '1234' },
  CY: { pattern: '9999', example: '1234' },
  CZ: { pattern: '99999', example: '12345' },
  DE: { pattern: '99999', example: '12345' },
  DK: { pattern: '9999', example: '1234' },
  DO: { pattern: '99999', example: '12345' },
  DZ: { pattern: '99999', example: '12345' },
  EC: { pattern: '999999', example: '123456' },
  EE: { pattern: '99999', example: '12345' },
  EG: { pattern: '99999', example: '12345' },
  ES: { pattern: '99999', example: '12345' },
  ET: { pattern: '9999', example: '1234' },
  FI: { pattern: '99999', example: '12345' },
  FK: { pattern: 'FIQQ 1ZZ', example: 'FIQQ 1ZZ' },
  FM: { pattern: '99999[-9999]', example: '12345-7689' },
  FO: { pattern: '999', example: '123' },
  FR: { pattern: '99999', example: '12345' },
  GB: { pattern: 'AA9A 9AA', example: 'SW1A 1AA' },
  GE: { pattern: '9999', example: '1234' },
  GF: { pattern: '97300-97390', example: '97300' },
  GG: { pattern: 'GY9 9AA', example: 'GY1 1AA' },
  GI: { pattern: 'GX11 1AA', example: 'GX11 1AA' },
  GL: { pattern: '9999', example: '1234' },
  GN: { pattern: '999', example: '123' },
  GP: { pattern: '97100-97190', example: '97100' },
  GR: { pattern: '99999', example: '12345' },
  GS: { pattern: 'SIQQ 1ZZ', example: 'SIQQ 1ZZ' },
  GT: { pattern: '99999', example: '12345' },
  GU: { pattern: '99999[-9999]', example: '12345-7689' },
  GW: { pattern: '9999', example: '1234' },
  HM: { pattern: '9999', example: '1234' },
  HN: { pattern: 'HN99999', example: 'HN12345' },
  HR: { pattern: '99999', example: '12345' },
  HT: { pattern: '9999', example: '1234' },
  HU: { pattern: '9999', example: '1234' },
  IC: { pattern: '99999', example: '12345' },
  ID: { pattern: '99999', example: '12345' },
  IE: { pattern: 'A99 A999', example: 'D02 AF30' },
  IL: { pattern: '9999999', example: '1234567' },
  IM: { pattern: 'IM9 9AA', example: 'IM1 1AA' },
  IN: { pattern: '999999', example: '123456' },
  IO: { pattern: 'BBND 1ZZ', example: 'BBND 1ZZ' },
  IQ: { pattern: '99999', example: '12345' },
  IR: { pattern: '9999999999', example: '1234567890' },
  IS: { pattern: '999', example: '123' },
  IT: { pattern: '99999', example: '12345' },
  JE: { pattern: 'JE9 9AA', example: 'JE1 1AA' },
  JM: { pattern: '99', example: '12' },
  JO: { pattern: '99999', example: '12345' },
  JP: { pattern: '999-9999', example: '100-0001' },
  KE: { pattern: '99999', example: '12345' },
  KG: { pattern: '999999', example: '123456' },
  KH: { pattern: '99999', example: '12345' },
  KR: { pattern: '99999', example: '12345' },
  KW: { pattern: '99999', example: '12345' },
  KY: { pattern: 'KY9-9999', example: 'KY1-1234' },
  KZ: { pattern: '999999', example: '123456' },
  LA: { pattern: '99999', example: '12345' },
  LB: { pattern: '9999 or 9999 9999', example: '1234 1234' },
  LC: { pattern: 'LC99 999', example: 'LC12 345' },
  LI: { pattern: '9999', example: '1234' },
  LK: { pattern: '99999', example: '12345' },
  LR: { pattern: '9999', example: '1234' },
  LS: { pattern: '999', example: '123' },
  LT: { pattern: 'LT-99999', example: 'LT-01100' },
  LU: { pattern: '9999', example: '1234' },
  LV: { pattern: 'LV-9999', example: 'LV-1050' },
  LY: { pattern: '99999', example: '12345' },
  MA: { pattern: '99999', example: '12345' },
  MC: { pattern: '98000-98099', example: '98000' },
  MD: { pattern: 'MD-9999', example: 'MD-1234' },
  ME: { pattern: '99999', example: '12345' },
  MF: { pattern: '97150', example: '97150' },
  MG: { pattern: '999', example: '123' },
  MH: { pattern: '99999[-9999]', example: '12345-7689' },
  MK: { pattern: '9999', example: '1234' },
  MM: { pattern: '99999', example: '12345' },
  MN: { pattern: '99999', example: '12345' },
  MP: { pattern: '99999[-9999]', example: '12345-7689' },
  MQ: { pattern: '99999', example: '12345' },
  MS: { pattern: 'MSR 9999', example: 'MSR 1110' },
  MT: { pattern: 'AAA 9999', example: 'ABC 1234' },
  MU: { pattern: '99999', example: '12345' },
  MV: { pattern: '99999', example: '12345' },
  MX: { pattern: '99999', example: '12345' },
  MY: { pattern: '99999', example: '12345' },
  MZ: { pattern: '9999', example: '1234' },
  NA: { pattern: '99999', example: '12345' },
  NC: { pattern: '98800-98890', example: '98800' },
  NE: { pattern: '9999', example: '1234' },
  NF: { pattern: '9999', example: '1234' },
  NG: { pattern: '999999', example: '123456' },
  NI: { pattern: '99999', example: '12345' },
  NL: { pattern: '9999 AA', example: '1234 AB' },
  NO: { pattern: '9999', example: '1234' },
  NP: { pattern: '99999', example: '12345' },
  NZ: { pattern: '9999', example: '1234' },
  OM: { pattern: '999', example: '123' },
  PA: { pattern: '9999', example: '1234' },
  PE: { pattern: '99999', example: '12345' },
  PF: { pattern: '98700-98790', example: '98700' },
  PG: { pattern: '999', example: '123' },
  PH: { pattern: '9999', example: '1234' },
  PK: { pattern: '99999', example: '12345' },
  PL: { pattern: '99-999', example: '44-100' },
  PM: { pattern: '97500', example: '97500' },
  PN: { pattern: 'PCRN 1ZZ', example: 'PCRN 1ZZ' },
  PR: { pattern: '99999[-9999]', example: '12345-7689' },
  PS: { pattern: '999', example: '123' },
  PT: { pattern: '9999-999', example: '1234-123' },
  PW: { pattern: '99999[-9999]', example: '12345-7689' },
  PY: { pattern: '9999', example: '1234' },
  RE: { pattern: '97400-97490', example: '97400' },
  RO: { pattern: '999999', example: '123456' },
  RS: { pattern: '99999', example: '12345' },
  RU: { pattern: '999999', example: '101000' },
  SA: { pattern: '99999[-9999]', example: '12345-7689' },
  SD: { pattern: '99999', example: '12345' },
  SE: { pattern: '99999', example: '12345' },
  SG: { pattern: '999999', example: '123456' },
  SH: { pattern: 'STHL 1ZZ', example: 'STHL 1ZZ' },
  SI: { pattern: '9999', example: '1234' },
  SJ: { pattern: '9999', example: '1234' },
  SK: { pattern: '99999', example: '12345' },
  SM: { pattern: '47890-47899', example: '47890' },
  SN: { pattern: '99999', example: '12345' },
  SO: { pattern: 'AA 99999', example: 'AW 12345' },
  SV: { pattern: '9999', example: '1234' },
  SZ: { pattern: 'A999', example: 'S123' },
  TC: { pattern: 'TKCA 1ZZ', example: 'TKCA 1ZZ' },
  TD: { pattern: '99999', example: '12345' },
  TH: { pattern: '99999', example: '12345' },
  TJ: { pattern: '999999', example: '123456' },
  TM: { pattern: '999999', example: '123456' },
  TN: { pattern: '9999', example: '1234' },
  TR: { pattern: '99999', example: '12345' },
  TT: { pattern: '999999', example: '123456' },
  TW: { pattern: '999[-99]', example: '123-45' },
  TZ: { pattern: '99999', example: '12345' },
  UA: { pattern: '99999', example: '12345' },
  US: { pattern: '99999[-9999]', example: '12345-7689' },
  UY: { pattern: '99999', example: '12345' },
  UZ: { pattern: '999999', example: '123456' },
  VA: { pattern: '00120', example: '00120' },
  VC: { pattern: 'VC9999', example: 'VC1234' },
  VE: { pattern: '9999 or 9999-A', example: '1234-A' },
  VG: { pattern: 'VG9999', example: 'VG1234' },
  VI: { pattern: '99999[-9999]', example: '12345-7689' },
  VN: { pattern: '999999', example: '123456' },
  WF: { pattern: '98600-98690', example: '98600' },
  WS: { pattern: 'WS99999', example: 'WS1234' },
  YT: { pattern: '99999', example: '12345' },
  ZA: { pattern: '9999', example: '1234' },
  ZM: { pattern: '99999', example: '12345' },
};

const ALPHA3_TO_ALPHA2: Readonly<Record<string, string>> = {
  AND: 'AD',
  AFG: 'AF',
  AIA: 'AI',
  ALB: 'AL',
  ARM: 'AM',
  ATA: 'AQ',
  ARG: 'AR',
  ASM: 'AS',
  AUT: 'AT',
  AUS: 'AU',
  ALA: 'AX',
  AZE: 'AZ',
  BIH: 'BA',
  BRB: 'BB',
  BGD: 'BD',
  BEL: 'BE',
  BGR: 'BG',
  BHR: 'BH',
  BLM: 'BL',
  BRN: 'BN',
  BOL: 'BO',
  BRA: 'BR',
  BTN: 'BT',
  BLR: 'BY',
  CAN: 'CA',
  CCK: 'CC',
  CHE: 'CH',
  CHL: 'CL',
  CHN: 'CN',
  COL: 'CO',
  CRI: 'CR',
  CUB: 'CU',
  CPV: 'CV',
  CXR: 'CX',
  CYP: 'CY',
  CZE: 'CZ',
  DEU: 'DE',
  DNK: 'DK',
  DOM: 'DO',
  DZA: 'DZ',
  ECU: 'EC',
  EST: 'EE',
  EGY: 'EG',
  ESP: 'ES',
  ETH: 'ET',
  FIN: 'FI',
  FLK: 'FK',
  FSM: 'FM',
  FRO: 'FO',
  FRA: 'FR',
  GBR: 'GB',
  GEO: 'GE',
  GUF: 'GF',
  GGY: 'GG',
  GIB: 'GI',
  GRL: 'GL',
  GIN: 'GN',
  GLP: 'GP',
  GRC: 'GR',
  SGS: 'GS',
  GTM: 'GT',
  GUM: 'GU',
  GNB: 'GW',
  HMD: 'HM',
  HND: 'HN',
  HRV: 'HR',
  HTI: 'HT',
  HUN: 'HU',
  IDN: 'ID',
  IRL: 'IE',
  ISR: 'IL',
  IMN: 'IM',
  IND: 'IN',
  IOT: 'IO',
  IRQ: 'IQ',
  IRN: 'IR',
  ISL: 'IS',
  ITA: 'IT',
  JEY: 'JE',
  JAM: 'JM',
  JOR: 'JO',
  JPN: 'JP',
  KEN: 'KE',
  KGZ: 'KG',
  KHM: 'KH',
  KOR: 'KR',
  KWT: 'KW',
  CYM: 'KY',
  KAZ: 'KZ',
  LAO: 'LA',
  LBN: 'LB',
  LCA: 'LC',
  LIE: 'LI',
  LKA: 'LK',
  LBR: 'LR',
  LSO: 'LS',
  LTU: 'LT',
  LUX: 'LU',
  LVA: 'LV',
  LBY: 'LY',
  MAR: 'MA',
  MCO: 'MC',
  MDA: 'MD',
  MNE: 'ME',
  MAF: 'MF',
  MDG: 'MG',
  MHL: 'MH',
  MKD: 'MK',
  MMR: 'MM',
  MNG: 'MN',
  MNP: 'MP',
  MTQ: 'MQ',
  MSR: 'MS',
  MLT: 'MT',
  MUS: 'MU',
  MDV: 'MV',
  MEX: 'MX',
  MYS: 'MY',
  MOZ: 'MZ',
  NAM: 'NA',
  NCL: 'NC',
  NER: 'NE',
  NFK: 'NF',
  NGA: 'NG',
  NIC: 'NI',
  NLD: 'NL',
  NOR: 'NO',
  NPL: 'NP',
  NZL: 'NZ',
  OMN: 'OM',
  PAN: 'PA',
  PER: 'PE',
  PYF: 'PF',
  PNG: 'PG',
  PHL: 'PH',
  PAK: 'PK',
  POL: 'PL',
  SPM: 'PM',
  PCN: 'PN',
  PRI: 'PR',
  PSE: 'PS',
  PRT: 'PT',
  PLW: 'PW',
  PRY: 'PY',
  REU: 'RE',
  ROU: 'RO',
  SRB: 'RS',
  RUS: 'RU',
  SAU: 'SA',
  SDN: 'SD',
  SWE: 'SE',
  SGP: 'SG',
  SHN: 'SH',
  SVN: 'SI',
  SJM: 'SJ',
  SVK: 'SK',
  SMR: 'SM',
  SEN: 'SN',
  SOM: 'SO',
  SLV: 'SV',
  SWZ: 'SZ',
  TCA: 'TC',
  TCD: 'TD',
  THA: 'TH',
  TJK: 'TJ',
  TKM: 'TM',
  TUN: 'TN',
  TUR: 'TR',
  TTO: 'TT',
  TWN: 'TW',
  TZA: 'TZ',
  UKR: 'UA',
  USA: 'US',
  URY: 'UY',
  UZB: 'UZ',
  VAT: 'VA',
  VCT: 'VC',
  VEN: 'VE',
  VGB: 'VG',
  VIR: 'VI',
  VNM: 'VN',
  WLF: 'WF',
  WSM: 'WS',
  MYT: 'YT',
  ZAF: 'ZA',
  ZMB: 'ZM',
};

export function getPostalCodeHint(countryCode: string | null | undefined): PostalCodeHint | null {
  if (!countryCode) return null;
  const normalized = countryCode.trim().toUpperCase();
  const alpha2 = normalized.length === 3 ? ALPHA3_TO_ALPHA2[normalized] : normalized;
  if (!alpha2) return null;
  return HINT_BY_ALPHA2[alpha2] ?? null;
}
